import { z } from 'zod';

export const validationMessages = {
  required: 'Preencha todos os campos para alterar sua senha.',
  weakPassword:
    'Senha muito fraca. Sua senha precisa ter no mínimo 8 caracteres, um número e uma letra.',
  sameAsCurrentPassword: 'A nova senha deve ser diferente da senha atual.',
  noMatch: 'A senha não corresponde com a informada no campo acima',
};

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, validationMessages.required),
    newPassword: z
      .string()
      .min(8, validationMessages.weakPassword)
      .refine(
        (password) => {
          const hasNumber = /\d/.test(password);
          const hasLetter = /[a-zA-Z]/.test(password);
          return hasNumber && hasLetter;
        },
        {
          message: validationMessages.weakPassword,
        }
      ),
    confirmPassword: z.string().min(1, validationMessages.required),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: validationMessages.noMatch,
    path: ['confirmPassword'],
  })
  .refine((data) => data.currentPassword !== data.newPassword, {
    message: validationMessages.sameAsCurrentPassword,
    path: ['newPassword'],
  });

export type ChangePasswordFormData = z.infer<typeof changePasswordSchema>;
